export type Profiles =
  | MtbProfile
  | BikeProfile;

export type MtbProfile = 'mtb';
export type BikeProfile = 'bike';

export const defaultProfile: Profiles = 'mtb';
